import { BinaryResponse } from '@/Api';
import { Nullable } from '@/Types';
import { IPrinterInfo, IPrintService, PrintResult } from './IPrintService';
import { PrintUnionDocumentRequest } from '@/Api/DocumentTemplates/Requests/PrintUnionDocumentRequest';
import { DocumentTemplateApi } from '@/Api/DocumentTemplates/DocumentTemplatesApi';

class WebPrintService implements IPrintService {
  getPrinters(): IPrinterInfo[] {
    return [];
  }

  getDefaultPrinter(): Nullable<IPrinterInfo> {
    return null;
  }

  async printHandler(
    request: PrintUnionDocumentRequest,
    templateGuid: string,
    callback?: (params: number[]) => void,
  ): Promise<PrintResult> {
    try {
      const response = await DocumentTemplateApi.printUnionDocument(templateGuid, request);

      callback?.(request.orderIds);

      return this.openInWindow(response);
    } catch (error) {
      return PrintResult.ErrorPrint;
    }
  }

  async printDocument(file: BinaryResponse): Promise<PrintResult> {
    return this.openInWindow(file);
  }

  async printLabel(file: string): Promise<PrintResult> {
    return this.openInWindow(file);
  }

  normalizeFile(file: BinaryResponse | string): BinaryResponse {
    if (typeof file === 'object') {
      return file;
    } else {
      return {
        contentType: '',
        fileName: '',
        data: Buffer.from(file, 'base64'),
      };
    }
  }

  openInWindow(file: BinaryResponse | string): PrintResult {
    try {
      const result = this.normalizeFile(file);
      const blob = new Blob([result.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);

      window.open(url);
      setTimeout(() => window.URL.revokeObjectURL(url), 10000);

      return PrintResult.Success;
    } catch (error) {
      return PrintResult.ErrorPrint;
    }
  }
}

export const printService = new WebPrintService();
